import { render, staticRenderFns } from "./adminDiscount.vue?vue&type=template&id=3d9f8261&"
import script from "./adminDiscount.vue?vue&type=script&lang=js&"
export * from "./adminDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports